/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_Intro_PostInputs */

const tr_kvkkbasvuru_s2_intro_post = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'ne başvurularınızı aşağıdaki kanallardan iletebilirsiniz:`)
};

const en_kvkkbasvuru_s2_intro_post = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` through the following channels:`)
};

const de_kvkkbasvuru_s2_intro_post = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` können Sie über die folgenden Wege übermitteln:`)
};

const ru_kvkkbasvuru_s2_intro_post = /** @type {(inputs: Kvkkbasvuru_S2_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` вы можете направить по следующим каналам:`)
};

/**
* | output |
* | --- |
* | "through the following channels:" |
*
* @param {Kvkkbasvuru_S2_Intro_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_intro_post = /** @type {((inputs?: Kvkkbasvuru_S2_Intro_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_Intro_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_intro_post(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_intro_post(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_intro_post(inputs)
	return tr_kvkkbasvuru_s2_intro_post(inputs)
});